import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { SwiperProps } from 'swiper/react';
import { NavigationOptions } from 'swiper/types';
import { Carousel } from 'atoms/Carousel';
import { NavigationButtons, NavigationTypes } from './NavigationButtons';
import styles from './slider.module.css';

export interface SliderProps extends SwiperProps {
  buttonContainerClass?: string;
  buttonPrevClass?: string;
  buttonNextClass?: string;
  sliderClassName?: string;
  navigationType?: NavigationTypes;
}

export const Slider: FC<PropsWithChildren<SliderProps>> = ({
  className,
  children,
  buttonPrevClass,
  buttonNextClass,
  buttonContainerClass,
  navigation,
  pagination,
  wrapperClass,
  navigationType = NavigationTypes.DEFAULT,
  ...restSliderProps
}) => {
  const nav = (
    typeof navigation === 'boolean' ? { enabled: navigation } : navigation
  ) as NavigationOptions;

  return (
    <div className={clsx(styles.root, className)}>
      <Carousel
        navigation={{
          enabled: false,
          prevEl: '.slide-prev',
          nextEl: '.slide-next',
          disabledClass: styles.buttonDisabled,
          lockClass: styles.lock,
          ...nav,
        }}
        pagination={{
          horizontalClass: styles.paginationContainer,
          lockClass: styles.lock,
          ...(typeof pagination !== 'boolean' ? pagination : {}),
        }}
        wrapperClass={clsx(
          styles[`navigationWrapper-${navigationType}`],
          wrapperClass,
        )}
        {...restSliderProps}
      >
        {children}
      </Carousel>

      <NavigationButtons
        navigation={nav}
        type={navigationType}
        classes={{
          container: buttonContainerClass,
          prev: buttonPrevClass,
          next: buttonNextClass,
        }}
      />
    </div>
  );
};
